import { Component, Input, Output, EventEmitter } from '@angular/core';

import { DataManager } from 'techlify-ng';
import { AlertService } from 'techlify-ng';
import { RequestErrorService } from 'techlify-ng';

import { Client } from './client.model';

/**
 * Controller used to edit a Client
 * 
 * @author Floyd Kissoon
 * @since 20190604
 */
@Component({
    selector: 'client-edit',
    templateUrl: './client-form.html'
})
export class ClientEditComponent {
    
    @Input() client: Client;
    @Output() onSave = new EventEmitter<Client>();
    private isWorking = false;
    constructor(private dataManager: DataManager, private alertService: AlertService,
        private errorHandler: RequestErrorService) { }

    save() {
        this.isWorking = true;
        this.dataManager.PUT('api/clients/' + this.client.id, this.client).then(
            res => {
                this.onSave.emit(res.item);
                this.alertService.addAlert('Successfully updated client', 'success');
                this.isWorking = false;
            },
            error => {
                this.errorHandler.handleError(error);
                this.isWorking = false;
            }
        );
    }
}